module.exports = __webpack_public_path__ + "img/wolkvoorgrond_600x600px.baf7ab3e.png";